import {
  CreateOrganizationRequest,
  CreateOrganizationResponse,
  GetOrganisationsResponse,
  UpdateOrganizationRequest,
} from "@/types/organizationTypes";
import {createApi, FetchArgs} from "@reduxjs/toolkit/query/react";
import platformAuthConfig from "./platformConfig";

export type TagTypes = "Organisations";

const organisationApi = createApi({
  reducerPath: "organisationApi",
  ...platformAuthConfig(),
  tagTypes: ["Organisations"],
  endpoints: (builder) => ({
    createOrganization: builder.mutation<
      CreateOrganizationResponse,
      CreateOrganizationRequest
    >({
      query: (config): FetchArgs => ({
        url: "/organization/create",
        method: "POST",
        body: config,
      }),
      invalidatesTags: ["Organisations"],
    }),
    deleteOrganisation: builder.mutation<void, string>({
      query: (org_id): FetchArgs => ({
        url: `/organization/${org_id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Organisations"],
    }),
    updateOrganisation: builder.mutation<void, UpdateOrganizationRequest>({
      query: (config): FetchArgs => ({
        url: `/organization/${config.org_id}`,
        method: "PUT",
        body: config,
      }),
      invalidatesTags: ["Organisations"],
    }),
    getOrganisations: builder.query<GetOrganisationsResponse, void>({
      query: (): FetchArgs => ({
        url: "/organization/",
        method: "GET",
      }),
      providesTags: ["Organisations"],
    }),
  }),
});

export const {
  useCreateOrganizationMutation,
  useGetOrganisationsQuery,
  useDeleteOrganisationMutation,
  useUpdateOrganisationMutation,
} = organisationApi;

export default organisationApi;
